import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns combined values of isMobile, isTablet & isSmallTablet
 */
export default function useIsDesktop(): boolean {
    const {
        isMobile,
        isTablet,
        isSmallTablet,
    } = useAppSelector((state) => state?.page)

    return !isMobile && !isTablet && !isSmallTablet
}